<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @addInBound="addInBound"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
        @addNoticeOut="() => (chooseNoticeOutVisible = true)"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseNoticeOut
      :visible.sync="chooseNoticeOutVisible"
      :listAmzFtyNoticeOutStatus="['F']"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseNoticeOutConfirm"
    />
    <InBoundTable
      :visible.sync="addInBoundData.addInBoundVisible"
      :tableData="addInBoundData.table"
      :title="$l('dialog_title_out_of_stock_products') || '出库产品缺货'"
      confirm-on-close
      reserve
      @confirm="addInBoundConfirm"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import ChooseNoticeOut from '../choose-notice-out'
import InBoundTable from '../in-bound-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, ChooseNoticeOut, InBoundTable },
  data() {
    return {
      usePage: true,
      chooseNoticeOutVisible: false,
      table: [],
      addInBoundData: {
        table: [],
        scmCode: '',
        buyerCode: '',
        buyerName: '',
        addInBoundVisible: false,
      },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.addInBoundData.buyerCode = userCode || ''
        this.addInBoundData.buyerName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFtyOutboundListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, data = {} }) {
      const { amzFtyOutboundCode = '', amzFtyOutboundNo = '' } = data
      let params = { pageType }
      let query = {}
      if (amzFtyOutboundCode) params = { ...params, amzFtyOutboundCode }
      if (amzFtyOutboundNo) query = { ...query, amzFtyOutboundNo }
      this.$router.push({
        name: 'ecom-awsBiz-ftyOutbound-detail',
        params,
        query,
      })
    },
    chooseNoticeOutConfirm(data) {
      if (!data || !data.length) return
      const amzFtyNoticeOutCodeList = data.map((item) => {
        return item.amzFtyNoticeOutCode
      })
      this.loading = true
      this.$api
        .ecomAmzFtyOutboundAddByNoticeOutListApi({ amzFtyNoticeOutCodeList })
        .then((res) => {
          this.loading = false
          if (!res) return
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.reload()
        })
        .catch(() => {
          this.loading = false
        })
    },
    addInBoundConfirm(data) {
      this.$router.push({
        name: 'ecom-awsBiz-ftyInbound-detail',
        params: {
          scmCode: this.addInBoundData.scmCode,
          table: data,
          pageType: 'add',
        },
        query: {},
      })
    },
    addInBound(data, scmCode) {
      this.addInBoundData.addInBoundVisible = true
      this.addInBoundData.table = data
      this.addInBoundData.scmCode = scmCode
    },
    reset() {
      this.addInBoundData.addInBoundVisible = false
      this.addInBoundData.table = []
      this.addInBoundData.scmCode = ''
    },
  },
}
</script>
